import { NavigateFunction } from "react-router-dom";
import { TableDatum } from "../components/Table/types";

// Type for data that can be used with the navigation utility
// Extends TableDatum which is the type used by the Table component
type NavigationData = TableDatum & {
  _newTab?: boolean;
  [key: string]: any;
};

/**
 * Helper function for table row navigation with support for new tabs on cmd/ctrl+click
 *
 * @param data - The row data (may include _newTab flag)
 * @param navigate - React Router's navigate function
 * @param path - The path to navigate to (e.g., "/schema/${id}")
 * @param shouldNavigate - Optional function to determine if navigation should occur
 */
export const tableRowNavigation = (
  data: NavigationData,
  navigate: NavigateFunction,
  path: string,
  shouldNavigate?: (data: NavigationData) => any
): void => {
  // If there's a condition for navigation, and it's not met, do nothing
  if (shouldNavigate && !Boolean(shouldNavigate(data))) {
    return;
  }

  // Replace any placeholders in the path with actual values
  const resolvedPath = path.replace(/\${id}/g, data.id?.toString() || "");

  if (data._newTab) {
    // For cmd/ctrl+click, open in a new tab
    window.open(resolvedPath, "_blank");
  } else {
    // For normal clicks, use React Router navigation
    navigate(resolvedPath);
  }
};
